export default __webpack_public_path__ + "static/media/Insight_data_equation.42e408af.svg";